import { MarkdownOutput, RenderIf } from 'react-rainbow-components';
import { useNavigate } from 'react-router-dom';
import Button from 'components/Button';
import useAgentData from 'hooks/useAgentData';
import { Container, DescriptionContainer, Row } from './styled';
import { FormFooter, StyledLoadingShape } from '../styled';

interface AdditionalInfoProps {
    canEditAgent?: boolean
}

const AdditionalInfo = ({
    canEditAgent = false,
}: AdditionalInfoProps) => {
    const { agent, isLoading: isLoadingAgent } = useAgentData();
    const navigate = useNavigate();

    return (
        <Container>
            <RenderIf isTrue={isLoadingAgent}>
                <StyledLoadingShape />
                <StyledLoadingShape />
                <StyledLoadingShape />
                <StyledLoadingShape />
            </RenderIf>
            <RenderIf isTrue={!isLoadingAgent}>
                <DescriptionContainer>
                    <MarkdownOutput value={agent?.description} />
                </DescriptionContainer>
            </RenderIf>
            <Row>
                <FormFooter>
                    <Button
                        label="Edit Additional Info"
                        variant="brand"
                        borderRadius="semi-rounded"
                        disabled={!canEditAgent}
                        onClick={() => navigate('edit-additional-info')}
                    />
                </FormFooter>
            </Row>
        </Container>
    );
};

export default AdditionalInfo;
